import { createContext, useState } from "react";
import { useDispatch } from "react-redux";

import {
  editConfigService,
  getConfigsService,
} from "./../../../services/userServices";
import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "./../../../redux/actions/loadingActions/loadingActions";
import {
  toastErrorMessage,
  toastSuccessMessage,
} from "../../../utils/toastMessage/toastMessage";

export const configAdminContext = createContext({
  configItems: [],
  setConfigItems: () => {},
  config: {},
  setConfig: () => {},
  handleGetConfigItemList: () => {},
  handleEditConfigItem: () => {},
});

const ConfigAdminContext = ({ children }) => {
  // Redux Dispatch
  const dispatch = useDispatch();

  const [configItems, setConfigItems] = useState([]);
  const [config, setConfig] = useState({});
  const [totalCount, setTotalCount] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [limit, setLimit] = useState(100);

  // Handle Get Config Item List Method
  const handleGetConfigItemList = async (event) => {
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getConfigsService();
      if (status === 200) {
        setConfigItems(data);
        setTotalCount(data.count);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Edit Config Item Method
  const handleEditConfigItem = async (event) => {
    event?.preventDefault();
    const element = event.target.value;
    const isCheckbox = element.type === "checkbox";
    const value = isCheckbox ? String(element.checked) : element.value;

    const objData = {
      key: config.key,
      value,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await editConfigService(objData);
      if (status === 200) {
        toastSuccessMessage("آیتم با موفقیت ویرایش شد");
        handleGetConfigItemList();
        setConfig({});
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <configAdminContext.Provider
      value={{
        configItems,
        setConfigItems,
        config,
        setConfig,
        totalCount,
        setTotalCount,
        pageNumber,
        setPageNumber,
        limit,
        setLimit,
        handleGetConfigItemList,
        handleEditConfigItem,
      }}
    >
      {children}
    </configAdminContext.Provider>
  );
};

export default ConfigAdminContext;
